<template>
  <div id="ispclayer" v-show="ispcState">
    <div class="pcewm"><img src="./img/ewm.jpg" /></div>
    <span class="text">请使用手机端浏览</span>
  </div>
</template>

<script>
export default {
  name: "Ispc",
  data() {
    return {
      ispcState: false,
    };
  },
  mounted() {
    this.whatpc()
    let _this=this

    window.onresize=function(){
      setTimeout(()=>{
        _this.whatpc();
      },200)
    }
  },
  methods: {
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = [
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod",
      ];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
    whatpc() {
      if (this.IsPC()) {
        this.ispcState = true;
      } else {
        this.ispcState = false;
      }
    },
  },
};
</script>

<style scoped lang="less">
*::-webkit-scrollbar {
  display: none;
}

#ispclayer {
  background-color: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: fixed;
  width: 100vw;
  height: 100vh;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  .text {
    font-size: 24px;
  }
  z-index: 111;
}

.pcewm{
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/ispc/Ispc.vue